// Generated by ReScript, PLEASE EDIT WITH CARE


var messagesTitle = {
  id: "f0af8f30-efc1-4f2f-9d66-794ee76743ab",
  defaultMessage: "Messages"
};

var messagesModalTitleNew = {
  id: "fc0ee07e-8b4c-4af4-86c0-5b6813994e87",
  defaultMessage: "New message"
};

var messagesModalTitleUpdate = {
  id: "9b0ac2f2-22c1-41a5-a742-b7a7db5185c0",
  defaultMessage: "Update message"
};

var messagesModalObject = {
  id: "2ba10ddd-1b67-4845-8ab2-5a903c3c8998",
  defaultMessage: "Message title"
};

var messagesModalMessage = {
  id: "2ba10ddd-1b67-4845-8ab2-5a903c3c8997",
  defaultMessage: "Message content"
};

var messagesModalGroup = {
  id: "db333c85-2703-4568-97c7-c9690f0cdbe4",
  defaultMessage: "Recipients:"
};

var messagesGroupAll = {
  id: "1b333c85-2703-4568-97c7-c9690f0cdbe4",
  defaultMessage: "All"
};

var messagesGroupRenaultSas = {
  id: "2b333c85-2703-4568-97c7-c9690f0cdbe4",
  defaultMessage: "Renault SAS"
};

var messagesGroupNetwork = {
  id: "3b333c85-2703-4568-97c7-c9690f0cdbe4",
  defaultMessage: "Group network"
};

var messagesOwner = {
  id: "f7540a17-c3e9-48d8-a2c3-619b3c66d1af",
  defaultMessage: "Edited {editDate} by {editorName}"
};

export {
  messagesTitle ,
  messagesModalTitleNew ,
  messagesModalTitleUpdate ,
  messagesModalObject ,
  messagesModalMessage ,
  messagesModalGroup ,
  messagesGroupAll ,
  messagesGroupRenaultSas ,
  messagesGroupNetwork ,
  messagesOwner ,
}
/* No side effect */
